import { render, staticRenderFns } from "./UserFilesFromDocuments.vue?vue&type=template&id=95c67282&"
import script from "./UserFilesFromDocuments.vue?vue&type=script&lang=ts&"
export * from "./UserFilesFromDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports